import { render, staticRenderFns } from "./SkupKotizacijaDetails.vue?vue&type=template&id=609fcf54&scoped=true&"
import script from "./SkupKotizacijaDetails.vue?vue&type=script&lang=js&"
export * from "./SkupKotizacijaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609fcf54",
  null
  
)

export default component.exports